export default __webpack_public_path__ + "static/r_peters-c925d764a5f2303fbdbfe13285dd9a45.jpg";